import { Button, Loading } from '@startlibs/components';
import { getColor, getFetcher } from '@startlibs/utils';
import { transparentize } from 'polished';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import {CardHeader, SignInCard, SignInLayout} from '../components/SigninLayout';
import { PurviewFooter } from '../components/PurviewFooter';
import {wrapPromise} from '../hooks/useSuspense'

const lazyPasSystem = wrapPromise(() => getFetcher("/pasapi/systemref",null,{referrer:'/auth/'}))

export const RedirectLoading = styled.div`
  position: relative;
  margin: 2rem auto;
  font-size: 20px;
  font-weight: bold;
  color: ${getColor('main')};
  border-radius: 50%;
  background: ${props => transparentize(0.92, props.theme.colors.main)};
  width: 52px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  ${Loading} {
    border-color: ${props => transparentize(0.92, props.theme.colors.main)};
    border-top-color: ${getColor('main')};
  }
`

export const AdminSSOLogin = ({navigate, setCaseRequest, isNurse}) => {

  const pasSystem = lazyPasSystem.read()
  const providerInfo = {logoURL:pasSystem.systemWebHooks.systemLogoWebHook}
  const [ssoUrl, setSsoUrl] = useState('')
  const [timeToRedirect, setTimeToRedirect] = useState(5);

  const refreshTimer = (time) => {
  
    if (time > 1) {
      return time - 1
    }

    // Redirecting...
    if(ssoUrl.length > 0){
      window.location.href = ssoUrl
    }

    return 0;
  }

  useEffect(() => {
    setTimeout(() => {
      setTimeToRedirect(refreshTimer(timeToRedirect));
    }, 1000);
  });


  useEffect(() => {
    
    // OFICIAL
    if(pasSystem.ssoEntities.length == 1){
      setSsoUrl(pasSystem.ssoEntities[0].url)
    }
    
  }, [])


  return <><SignInLayout providerInfo={providerInfo} css="text-align:center;">
    <SignInCard>
      {/* Only one sso provider */}
      {pasSystem?.ssoEntities?.length == 1 && 
        <>
          <CardHeader>
            <h1>Loading Expert View</h1>
            <p>You will be redirected to {pasSystem?.ssoEntities[0].label || pasSystem.systemName} authentication page</p>
          </CardHeader>
          <RedirectLoading>
            <Loading size={52} borderWidth={5} absolute/>
            <div>{timeToRedirect}</div>
          </RedirectLoading>

          {pasSystem.ssoEntities?.map(sso => <Button.a highlight href={sso.url} css="min-width:12rem;">Take me now</Button.a>)}
          
        </>
      }

      {/* More than one sso provider */}
      {pasSystem?.ssoEntities?.length > 1 && <>
        <CardHeader>
          <h1>Expert View</h1>
          <h3>Select your {pasSystem.systemName} authentication page</h3>
        </CardHeader>
        {pasSystem.ssoEntities?.map(sso => 
          <div css="margin: 12px;">
            <Button.a highlight href={sso.url}>{sso.label || 'Use Single Sign On'}</Button.a>
          </div>)
        }
        </>
      }
    </SignInCard>
  </SignInLayout>
  <PurviewFooter />
  </>
}
